import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark text-white py-4 mt-auto">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h5>Shopy Sync App</h5>
                        <p className="small text-muted">
                            Bulk import, export, update & migrate your shop data with Google sheet.
                        </p>
                    </div>
                    <div className="col-md-6 text-md-end">
                        <p className="small">&copy; 2025 Shopy Sync. All rights reserved.</p>
                        <a href="/terms-conditions" className="text-white me-3">Terms & Conditions</a>
                        <a href="/privacy" className="text-white me-3">Privacy</a>
                        <a href="/cookies-policy" className="text-white me-3">Cookies Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;